export default "__VITE_ASSET__13LaMXQn__"